import React from 'react';
import {Container, Flex} from '@chakra-ui/react';
import {ValidateDomainsButton} from './ValidateDomainsButton';

export const ValidateDomains = () => {
  return (
    <Container fontSize="14" maxWidth="100%">
      <Flex justifyContent="flex-start" p={6}>
        <ValidateDomainsButton>Upload Domains</ValidateDomainsButton>
      </Flex>
    </Container>
  );
};
